<template>
  <div class="yxdw-wrap">
    <div class="yxdw-top">
      <div class="szkf-top-left">
        <div>
          <span class="cardNum">状态选择：</span>
          <select
            class="serinp"
            name
            v-model="searchStatus"
            @change="searchStatusChange"
          >
            <option value>全部</option>
            <option value="I">正常</option>
            <option value="B">禁用</option>
          </select>
        </div>
      </div>
      <div class="yxdw-top-right">
        <div :class="[{ yxdwchecked2: titleIndex == 2 }]" @click="operation(2)">
          创建
        </div>
        <div :class="[{ yxdwchecked2: titleIndex == 3 }]" @click="operation(3)">
          修改
        </div>
        <div :class="[{ yxdwchecked2: titleIndex == 0 }]" @click="operation(0)">
          账务处理
        </div>

        <div :class="[{ yxdwchecked2: titleIndex == 1 }]" @click="operation(1)">
          状态
        </div>
        <div :class="[{ yxdwchecked2: titleIndex == 4 }]" @click="operation(4)">
          可签单人员
        </div>

        <div :class="[{ yxdwchecked2: titleIndex == 5 }]" @click="operation(5)">
          刷新
        </div>

        <div
          :class="[{ yxdwchecked2: titleIndex == 2 }]"
          @click="operation(1)"
          v-if="false"
        >
          打印
        </div>

        <div
          :class="[{ yxdwchecked2: titleIndex == 3 }]"
          @click="operation(2)"
          v-if="false"
        >
          导出
        </div>
      </div>
    </div>
    <div class="yxdw-container">
      <img src="../assets/image/lq-bg.png" alt />
      <div>
        <div class="yxdw-con-wrap">
          <div class="yxdw-con-title">
            <div>序号</div>
            <div>协议单位名称</div>
            <div>信用额</div>
            <div>已消费</div>
            <div>余额</div>

            <div>有效期</div>
            <div>地址</div>
            <div>销售员</div>

            <div>客户类型</div>
            <div class="eight">联系人</div>
            <div>备注</div>
            <div>状态</div>
          </div>
          <div class="yxdw-con-contaniner">
            <transition-group name="list">
              <div
                :class="['yxdw-con-item', { yxdwchecked: yxdwIndex == index }]"
                v-for="(item, index) in list"
                :key="item.id"
                @click="chooseYxdw(index)"
                @dblclick="dblItem(index)"
              >
                <div>{{ index + 1 }}</div>
                <div>{{ item.name }}</div>
                <div>{{ curreny(item.creditlimit) }}</div>
                <div :class="[item.getDate >= 0 ? 'zheng' : 'fu']">
                  {{ curreny(item.creditxf) }}
                </div>
                <div>
                  {{
                    curreny(item.creditlimit - item.creditxf + item.creditdj)
                  }}
                </div>
                <div :title="item.begintime + '至' + item.endtime">
                  {{ item.endtime }}
                </div>

                <div
                  style="text-align: left"
                  :title="item.provincename + item.cityname + item.address"
                >
                  <span v-if="item.provincename">{{ item.provincename }}</span>
                  <span v-if="item.cityname">{{ item.cityname }}</span>
                </div>
                <div>{{ item.salesname }}</div>

                <div>{{ item.typename }}</div>
                <div class="eight">{{ item.linkman }}/{{ item.linkphone }}</div>
                <div :title="item.remark">{{ item.remark }}</div>
                <div v-if="item.ysstatus == 0">启用</div>
                <div v-else>禁用</div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>

    <div class="confirm-wrap" v-if="visible">
      <div class="confirm-inner">
        <div class="confirm-header">
          <span>{{ title }}</span>
          <img src="../assets/image/close.png" alt @click="close" />
        </div>
        <div class="confirm-container">
          <div class="confirm-message">{{ message }}</div>
          <div class="confirm-message1">{{ message1 }}</div>
          <div class="confirm-button">
            <div @click="confirm">确定</div>
            <div @click="close">取消</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRequest, postRequest } from '@/api/api1.js'
export default {
  data() {
    return {
      list: [],
      title: '',
      dojinyong: false,
      dozhangwu: false,
      dodaying: false,
      dodaochu: false,
      visible: false,
      title: '',
      message: '',
      message1: '',
      obj: {},
      index: 0,
      yxdwIndex: -1,
      searchStatus: 'I',
    }
  },
  computed: {
    titleIndex() {
      return this.$store.state.operationIndex
    },
  },

  watch: {
    titleIndex(val) {
      if (val == null) {
        this.refresh()
      }
    },
  },

  created() {
    this.$store.state.yingshoudakai = 1
    this.$store.state.yingxiaodakai = null

    document.addEventListener('keydown', this.keyDown)
    this.checkPower()
    if (this.$store.state.yingshouInfo.length > 0) {
      let result = JSON.parse(JSON.stringify(this.$store.state.yingshouInfo))
      let result2 = result.filter(function(item, index) {
        return item.receivableyn == 1
      })
      this.$store.state.yingshouInfo = result2
      // console.log(3333,this.$store.state.yingshouInfo)
      this.$store.state.yingshouInfo.forEach(item => {
        //console.log(44444, item);
        if (!item.provincename) {
          item.provincename = ''
        }
        if (!item.cityname) {
          item.cityname = ''
        }
        if (!item.address) {
          item.address = ''
        }
      })
      //console.log(5566, this.$store.state.yingshouInfo);
      // this.list = this.$store.state.yingshouInfo
      this.searchStatusChange()
    } else {
      let loadingInstance = this.$loading({
        text: '加载中',
      })
      getRequest(
        '/tCustomerInfo/selectAll?hotelId=' + localStorage.getItem('ihotelid')
      ).then(res => {
        this.$nextTick(() => {
          loadingInstance.close()
        })
        if (res.status == 200) {
          let result = JSON.parse(JSON.stringify(res.data))
          let result2 = result.filter(function(item, index) {
            return item.receivableyn == 1
          })
          result2.forEach(item => {
            //console.log(44444, item);
            if (!item.provincename) {
              item.provincename = ''
            }
            if (!item.cityname) {
              item.cityname = ''
            }
            if (!item.address) {
              item.address = ''
            }
          })
          // this.list = result2
          this.$store.state.yingshouInfo = result2
          this.searchStatusChange()
        } else {
          this.$mymessage({
            content: res.message,
            type: 'error',
            time: 3000,
            hasClose: true,
          })
        }
      })
    }
  },
  destroyed() {
    document.removeEventListener('keydown', this.keyDown)
  },
  methods: {
    keyDown(e) {
      if (e.keyCode == 27) {
        this.close()
      }
    },
    curreny(data) {
      data = Number(data).toFixed(2)
      return data
    },
    operation(index) {
      if (index == 0) {
        // alert("功能正在开发")
        if (this.yxdwIndex > -1) {
          let obj = this.list[this.yxdwIndex]
          this.$yingshoujiezhang({ obj })
        } else {
          this.$mymessage({
            content: '请选择需要操作的数据',
            type: 'error',
            time: 2000,
            hasClose: true,
          })
        }
      }
      if (index == 1) {
        if (this.yxdwIndex <= -1) {
          this.$mymessage({
            content: '请选择需要操作的数据',
            type: 'error',
            time: 2000,
            hasClose: true,
          })
          return
        }
        this.$store.state.operationIndex = index
        var item = this.list[this.yxdwIndex]
        this.changestatus(item, index)
      }
      if (index == 2) {
        this.$store.state.operationIndex = index
        let obj = {
          operation: '创建',
        }
        this.$ysgl({ obj })
      }
      if (index == 3) {
        if (this.yxdwIndex > -1) {
          let obj = this.list[this.yxdwIndex]
          obj.operation = '修改'
          this.$store.state.operationIndex = index
          this.$ysgl({ obj: JSON.parse(JSON.stringify(obj)) })
        } else {
          this.$mymessage({
            content: '请选择需要操作的数据',
            type: 'error',
            time: 2000,
            hasClose: true,
          })
        }
      }
      if (index == 4) {
        if (this.yxdwIndex > -1) {
          this.$store.state.operationIndex = index
          let obj = this.list[this.yxdwIndex]
          this.$keqiandan({ obj })
        } else {
          this.$mymessage({
            content: '请选择需要操作的数据',
            type: 'error',
            time: 2000,
            hasClose: true,
          })
        }
      }
      if (index == 5) {
        this.refresh('showMsg')
      }
    },
    chooseYxdw(index) {
      this.yxdwIndex = index
      this.$store.state.yingxiaodanweiIndex = index
    },

    dblItem(index) {
      this.yxdwIndex = index
      this.operation(3)
    },
    checkPower() {
      if (!this.power.checkedpower('0402000')) {
        //this.$mymessage({content: "当前工号无权查看此页面",type: "error",time: 3000,hasClose: true,});
        this.$router.push('/power')
      }
      this.dozhangwu = this.power.checkedpower('0402005')
      this.dojinyong = this.power.checkedpower('0402004')
      this.dodaying = this.power.checkedpower('0402006')
      this.dodaochu = this.power.checkedpower('0402007')
    },
    changestatus(item, index) {
      let newitem = JSON.parse(JSON.stringify(item))
      this.title = '状态设置'
      if (newitem.ysstatus == 0) {
        this.message = '是否确认将 “' + item.name + '” 的状态设置为 “禁用”'
        this.message1 = '禁用后 将无法使用此应收单位进行结账'
        newitem.ysstatus = 1
      } else {
        this.message = '是否确认将 “' + item.name + '” 的状态设置为 “启用”'
        this.message1 = ''
        newitem.ysstatus = 0
      }
      this.obj.id = newitem.id
      this.obj.ysstatus = newitem.ysstatus
      this.index = index
      this.visible = true
    },
    close() {
      this.visible = false
      this.obj = {}
      this.$store.state.operationIndex = -1
    },
    confirm() {
      //this.obj.hotelid = parseInt(localStorage.getItem("ihotelid"));
      postRequest('/tCustomerInfo/updateTCustomerInfo', this.obj).then(res => {
        if (res.status == 200) {
          //创建 添加 删除按钮设置没选中
          this.$mymessage({
            content: '设置成功',
            type: 'success',
            time: 2000,
            hasClose: true,
          })
          // this.list.splice(this.yxdwIndex, 1, res.data)
          this.refresh()
          this.visible = false
          this.$store.state.operationIndex = null
        } else {
          this.$mymessage({
            content: res.message,
            type: 'error',
            time: 2000,
            hasClose: true,
          })
        }
      })
    },

    refresh(tag) {
      let loadingInstance = this.$loading({
        text: '刷新中',
      })
      getRequest(
        '/tCustomerInfo/selectAll?hotelId=' + localStorage.getItem('ihotelid')
      ).then(res => {
        this.$nextTick(() => {
          loadingInstance.close()
        })
        if (res.status == 200) {
          if (tag == 'showMsg') {
            this.$mymessage({
              content: '刷新成功',
              type: 'success',
              time: 3000,
              hasClose: true,
            })
          }
          let result = JSON.parse(JSON.stringify(res.data))
          let result2 = result.filter(function(item, index) {
            return item.receivableyn == 1
          })
          result2.forEach(item => {
            //console.log(44444, item);
            if (!item.provincename) {
              item.provincename = ''
            }
            if (!item.cityname) {
              item.cityname = ''
            }
            if (!item.address) {
              item.address = ''
            }
          })
          // this.list = result2
          this.$store.state.yingshouInfo = result2
          this.searchStatusChange()
        } else {
          this.$mymessage({
            content: res.message,
            type: 'error',
            time: 3000,
            hasClose: true,
          })
        }
      })
    },

    searchStatusChange() {
      let result = JSON.parse(JSON.stringify(this.$store.state.yingshouInfo))
      result.forEach(item => {
        item.creditdj = !item.creditdj ? 0 : item.creditdj
      })
      if (this.searchStatus == 'I') {
        // 正常
        this.list = result.filter(item => {
          return item.ysstatus == 0
        })
      } else if (this.searchStatus == 'B') {
        // 禁用
        this.list = result.filter(item => {
          return item.ysstatus == 1
        })
      } else {
        // 全部
        this.list = result
      }

      console.log('this.list', this.list)
    },
  },
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.yxdw-wrap {
  width: 102%;
  height: 100%;
  margin-left: -1%;
  z-index: 99;
  position: relative;
  overflow: hidden;
}
.yxdw-top {
  width: 100%;
  height: 7%;
  padding: 0 3%;
  /* background: red; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2%;
}

.yxdw-top-right div {
  width: 30%;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}

.yxdwchecked2 {
  background: url(../assets/image/lq-bg2.png);
  color: #fb7a01;
  background-size: 100% 100%;
  font-weight: bolder;
}
.yxdw-top-right {
  width: 32%;
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
}
.yxdw-container {
  width: 100%;
  height: 93%;
  margin: 0 0 0;
  position: absolute;
  top: 8.5%;
}
.yxdw-container img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.yxdw-container > div {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 1% 3%;
  overflow: hidden;
}
.yxdw-con-wrap {
  width: 100%;
  height: 100%;
  padding: 2%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.yxdw-con-title {
  width: 100%;
  display: flex;
  flex-shrink: 0;
}
.yxdw-con-title div {
  text-align: center;
  color: #2c3036;
  font-size: 0.8em;
  line-height: 3.2em;
  width: 7.5%;
}
.yxdw-con-title div:nth-child(1) {
  width: 3%;
}
.yxdw-con-title div:nth-child(2) {
  width: 15%;
}
.yxdw-con-title div:nth-child(12) {
  width: 8%;
}
.yxdw-con-item div:nth-child(12) {
  width: 8%;
  /* margin:0 4% */
}

.yxdw-con-title .eight {
  width: 15%;
}
.yxdw-con-contaniner {
  color: #6d798e;
  font-size: 14px;
  flex: 1;
  overflow: auto;
}
.yxdw-con-item {
  display: flex;
  width: 100%;
  border: 1px solid transparent;
}
.yxdw-con-item div {
  text-align: center;
  line-height: 3em;
  width: 7.5%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.yxdw-con-item div:nth-child(2) {
  width: 15%;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.yxdw-con-item div:nth-child(1) {
  width: 3%;
}
.yxdw-con-item .eight {
  width: 15%;
}
.yxdw-con-contaniner.yxdw-con-contaniner .yxdwchecked {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  border: 1px solid #1471fe;
  border-radius: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.zhuangtai {
  height: 4em;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2c3036;
  box-shadow: 3px 3px 6px #a0bdee, -3px -3px 6px white;
  border-radius: 5px;
  cursor: pointer;
}
.confirm-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  position: fixed;
}
.confirm-wrap::after {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgb(161, 160, 160);
  opacity: 0.4;
  content: '';
  z-index: -1;
}
.confirm-inner {
  width: 500px;
  border-radius: 10px;
  overflow: hidden;
  background: #e8f0ff;
}
.confirm-header {
  width: 100%;
  height: 50px;
  padding: 0 8px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #2c3036;
}
.confirm-header img:hover {
  transform: scale(1.2);
  cursor: pointer;
}
.confirm-container {
  box-shadow: 0px 2px 4px #b9ccec inset;
  padding: 20px;
}
.confirm-message {
  height: 55px;
  font-size: 16px;
  color: #2c3036;
  margin-left: 20px;
}
.confirm-message1 {
  height: 40px;
  font-size: 12px;
  color: red;
  margin-left: 20px;
}

.confirm-button {
  width: 100%;
  font-size: 10px;
  color: #575f6b;
  display: flex;
  justify-content: center;
}
.confirm-button div:nth-child(1) {
  margin-right: 20px;
}

.confirm-button div {
  width: 120px;
  height: 30px;
  box-shadow: 4px 0px 10px #b9ccec, -4px -4px 10px #ffffff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1471fe;
  color: white;
  cursor: pointer;
}
.confirm-enter-active,
.confirm-leave-active {
  transition: all 1s;
}
.confirm-enter {
  opacity: 0;
}
.confirm-leave-to {
  opacity: 0;
}
.zheng {
  color: green;
}
.fu {
  color: red;
}

.szkf-top-left {
  width: 280px;
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  align-items: center;
  color: #575f6b;
}
.szkf-top-left div {
  width: 250px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.szkf-top-left div select {
  width: 160px;
}
.cardNum {
  display: inline-block;
  width: 35%;
  /* background: coral; */
  text-align: end;
  margin-right: 2%;
  flex-shrink: 0;
}
.serinp {
  color: #6d798e;
  font-size: 10px;
  /* border-radius: 3px; */
  border: none;
  outline: none;
  width: 170px;
  height: 28px;
  line-height: 28px;
  border: 1px solid #76a8f5;
  outline: none;
  border-radius: 3px;
  box-shadow: 2px 2px 4px #b1c9f1 inset, -2px -2px 4px #ffffff inset;
  /* appearance: none; */
  /* -webkit-appearance: none; */
  /* -moz-appearance: none; */
  padding-left: 8px;
  cursor: pointer;
  font-size: 14px;
}
</style>
